var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeroImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.08,
    height: 71.966,
    viewBox: "0 0 89.08 71.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_0_icon",
    "data-name": "0_icon",
    transform: "translate(-329.92 -659.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rp_2.152.000_Rp_500.000_INDONESIA_Rp_50.000",
    "data-name": "Rp 2.152.000 Rp 500.000 INDONESIA Rp 50.000",
    d: "M8.211-11.394A6.776,6.776,0,0,0,15.091-18.1a6.812,6.812,0,0,0-6.881-6.75A6.812,6.812,0,0,0,1.33-18.1,6.776,6.776,0,0,0,8.211-11.394ZM3.769,6.069H8.69L28.983-24.284H24.062ZM8.211-15.1a2.868,2.868,0,0,1-2.831-3,2.932,2.932,0,0,1,2.831-3.048A2.99,2.99,0,0,1,11.041-18.1,2.922,2.922,0,0,1,8.211-15.1ZM17.66-.115a6.812,6.812,0,0,0,6.881,6.75,6.785,6.785,0,0,0,6.881-6.75,6.749,6.749,0,0,0-6.881-6.706A6.776,6.776,0,0,0,17.66-.115Zm4.05,0a2.894,2.894,0,0,1,2.831-3,2.957,2.957,0,0,1,2.874,3,2.968,2.968,0,0,1-2.874,3.048A2.906,2.906,0,0,1,21.71-.115Z",
    transform: "translate(387.578 723.803)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rp_2.152.000_Rp_500.000_INDONESIA_Rp_50.000-2",
    "data-name": "Rp 2.152.000 Rp 500.000 INDONESIA Rp 50.000",
    d: "M29.589-35.5C28.2-48.24,18.342-56.8,4.9-56.8s-23.292,8.56-24.685,21.3c-.3,3.285-.3,6.37-.3,14.632s0,11.447.3,14.732c1.394,12.741,11.248,21.3,24.685,21.3S28.2,6.605,29.589-6.135c.3-3.285.3-6.47.3-14.732S29.888-32.214,29.589-35.5ZM17.446-7.429C16.848-.661,11.772,3.818,4.9,3.818S-7.041-.661-7.638-7.429c-.3-2.588-.3-5.972-.3-13.438s0-10.551.2-13.139A12.231,12.231,0,0,1,4.9-45.453,12.231,12.231,0,0,1,17.545-34.006c.2,2.588.2,5.674.2,13.139S17.744-10.017,17.446-7.429Z",
    transform: "translate(350 716)",
    fill: "#262626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroImage);
export default __webpack_public_path__ + "static/media/zeroImage.a3b139d2ff32c6dccbd816e2208a6360.svg";
export { ForwardRef as ReactComponent };